import * as React from 'react';
import { clsx } from 'clsx';
import * as style from './Socials.css';
import { ArticleHeading4 } from '@cian/ui-kit';
import { IconSocialTelegram24, IconSocialVK24, IconSocialYoutube24 } from '@cian/ui-kit-design-tokens/icons';

type ITSocialsProps = {
  theme: 'white' | 'black';
};

export const Socials: React.FC<ITSocialsProps> = ({ theme }) => {
  const iconColor = theme === 'white' ? 'black' : 'white';

  return (
    <div className={style['socials-container']}>
      <a href="https://t.me/cian_realtor" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`])}>
          <IconSocialTelegram24 />
        </div>
      </a>
      <a href="https://www.youtube.com/channel/UCiT0aVQJwOj2eEvGAckXJjA" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`])}>
          <IconSocialYoutube24 />
        </div>
      </a>
      <a href="https://vk.com/cian_pro" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`])}>
          <IconSocialVK24 />
        </div>
      </a>
      <a href="https://www.cian.ru/magazine/" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`], style[`icon-journal-${iconColor}`])}>
          <ArticleHeading4 color="icon-secondary-default">Циан.Журнал</ArticleHeading4>
        </div>
      </a>
    </div>
  );
};
